// extracted by mini-css-extract-plugin
export default {"whatsAppButton":"whatsAppButton_whatsAppButton__7sXAN"};